import { ListBookDto } from '@hermes/domains'
import { authenticatedApiInstance } from '../client'
import { PaginatedApiResponse } from '../types.api'

export const getWishlist = (params: { size?: number; page?: number }): Promise<PaginatedApiResponse<ListBookDto>> =>
  authenticatedApiInstance()
    .get<PaginatedApiResponse<ListBookDto>>('/wishlist', { params })
    .then((res) => res.data)

export const getWishlistBookIds = (): Promise<number[]> =>
  authenticatedApiInstance()
    .get<number[]>('/wishlist', { params: { schema: 'bookId' } })
    .then((res) => res.data)

export const createWishlistItemByBookId = (body: { bookId: number }) =>
  authenticatedApiInstance()
    .post('/wishlist', { ...body })
    .then((res) => res.data)

export const deleteWishlistItemByBookId = (bookId: number) =>
  authenticatedApiInstance()
    .delete(`/wishlist/${bookId}`)
    .then((res) => res.data)
